import React from 'react'

import UserSelect from 'components/UserSelect'
import TakeoverMessageBuilder from 'components/shared/MessagePreviews/TakeoverMessage'

import Editor from '../Editor'
import MessageCta from '../MessageCta'
import Card from '../Card'

const TakeoverMessage = ({
  message,
  onMessageChange,
  headline,
  onHeadlineChange,
  ctaCopy,
  selectedUser,
  onAuthorChange,
  defaultEmbed,
  hideCta,
}) => {
  return (
    <div className="playbook-message">
      <header className="playbook-title-header">
        <h2>Customize the message your users will see.</h2>
        <p>What do you want to say? Keep it short and sweet, be personal and human!</p>
      </header>
      <Card title="Takeover Message" description={headline} className="drift-form">
        <TakeoverMessageBuilder
          widgetContent={{ message, headline, ctaCopy, selectedUser }}
          defaultEmbed={defaultEmbed}
          hideCta={hideCta}
        />
        <div className="playbook-edit-message-heading">Headline</div>
        <input type="text" onChange={onHeadlineChange} value={headline} />
        <div className="playbook-edit-message-heading">Takeover Message Copy</div>
        <Editor value={message} onChange={onMessageChange} />
        <MessageCta />
        <div className="playbook-edit-message-heading">Send From</div>
        <UserSelect selectedUserId={selectedUser ? selectedUser.id : null} onUserIdChange={onAuthorChange} clearable={true} restrictCalendarUsers={true}/>
      </Card>
    </div>
  )
}

export default TakeoverMessage



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TakeoverMessage/component.js